import { render, staticRenderFns } from "./Member-Management.vue?vue&type=template&id=84249a1c&scoped=true&"
import script from "./Member-Management.vue?vue&type=script&lang=js&"
export * from "./Member-Management.vue?vue&type=script&lang=js&"
import style0 from "./Member-Management.vue?vue&type=style&index=0&id=84249a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84249a1c",
  null
  
)

export default component.exports